var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaceprofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3616_24481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5607 29.4188V8.79274C30.5607 7.69931 29.6661 6.80469 28.5727 6.80469H9.63649C8.54306 6.80469 7.64844 7.69931 7.64844 8.79274V29.4188C7.64844 30.5122 8.54306 31.4068 9.63649 31.4068H28.5727C29.6661 31.4068 30.5607 30.5122 30.5607 29.4188Z",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16075 28.2269C5.21643 27.9784 4.57031 27.0837 4.57031 26.0897V5.91098C4.57031 4.71815 5.56434 3.72412 6.80687 3.72412H25.2461C26.2401 3.72412 27.1347 4.41994 27.3832 5.31456",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0766 25.1462C2.13228 24.8977 1.48616 24.0031 1.48616 23.009V2.83031C1.43646 1.58778 2.43049 0.59375 3.67302 0.59375H22.1122C23.1062 0.59375 24.0009 1.28957 24.2494 2.18419",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6758 24.1509H16.2662V28.1767H14.6758V24.1509Z",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 22.0625H20.1764V28.1758H18.5859V22.0625Z",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4922 25.2446H24.0826V28.177H22.4922V25.2446Z",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6805 17.6908L17.7422 15.7524",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.652 15.2056L21.1172 17.6906",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3495 15.4544C24.8985 15.4544 25.3435 15.0093 25.3435 14.4603C25.3435 13.9113 24.8985 13.4663 24.3495 13.4663C23.8005 13.4663 23.3555 13.9113 23.3555 14.4603C23.3555 15.0093 23.8005 15.4544 24.3495 15.4544Z",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4237 19.428C20.9727 19.428 21.4177 18.983 21.4177 18.434C21.4177 17.885 20.9727 17.4399 20.4237 17.4399C19.8747 17.4399 19.4297 17.885 19.4297 18.434C19.4297 18.983 19.8747 19.428 20.4237 19.428Z",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0448 16.0012C17.5938 16.0012 18.0388 15.5562 18.0388 15.0072C18.0388 14.4582 17.5938 14.0132 17.0448 14.0132C16.4958 14.0132 16.0508 14.4582 16.0508 15.0072C16.0508 15.5562 16.4958 16.0012 17.0448 16.0012Z",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8612 19.1809C14.4102 19.1809 14.8552 18.7359 14.8552 18.1869C14.8552 17.6379 14.4102 17.1929 13.8612 17.1929C13.3122 17.1929 12.8672 17.6379 12.8672 18.1869C12.8672 18.7359 13.3122 19.1809 13.8612 19.1809Z",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2981 15.7524L14.5586 17.492",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3616_24481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaceprofile);
export default __webpack_public_path__ + "static/media/purchaceprofile.fb53d622b7c941d5fb709b864c2dde18.svg";
export { ForwardRef as ReactComponent };